const isCS = (_case) => {
  return _case.deliveryManner === 1;
}

const isForceps = (_case) => {
  return _case.deliveryManner === 5;
}

const isVacuum = (_case) => {
  return _case.deliveryManner === 6;
}

export default ([
  {
    label   : 'Delivery Date',
    itemKey : 'deliveryDate',
    decoder : 'formatDate'
  },
  {
    label   : 'Delivery AOG',
    itemKey : ['deliveryAOGType','deliveryAOG','deliveryWeeks', 'deliveryDays'],
    legend  : ['type', 'range', 'weeks', 'days'],
    decoder : null
  },
  {
    label   : 'Manner of Delivery',
    itemKey : 'deliveryManner',
    decoder : 'decodeDeliveryManner'
  },
  {
    label   : 'Primary/Repeat',
    itemKey : 'primaryRepeat',
    decoder : 'decodePrimaryRepeat',
    isVisible : (casedata) => casedata.deliveryManner === 1
  },
  {
    label   : 'Incision',
    itemKey : 'incision',
    decoder : 'decodeIncision',
    isVisible : (casedata) => casedata.deliveryManner === 1
  },
  {
    label   : 'Indication',
    itemKey : 'deliveryIndication',
    decoder : {'decodeIndicationCs': isCS, 'decodeIndicationForceps': isForceps, 'decodeIndicationVacuum': isVacuum},
    isVisible : (casedata) => casedata.deliveryManner === 1
  },
  {
    label   : 'Morbidities',
    itemKey : 'morbidities',
    decoder : 'decodeMorbidityCondition'
  },
  {
    label   : 'Number of Infants',
    itemKey : 'infantsNumber'
  },
  {
    label   : 'Neonatal',
    itemKey : 'neonatal'
  }
])
